import { render, staticRenderFns } from "./Lookup.vue?vue&type=template&id=5d8013b2&scoped=true&"
import script from "./Lookup.vue?vue&type=script&lang=js&"
export * from "./Lookup.vue?vue&type=script&lang=js&"
import style0 from "./Lookup.vue?vue&type=style&index=0&id=5d8013b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8013b2",
  null
  
)

export default component.exports